import request from '@/utils/request';

export function getShopChargeRulesPage(query) {
  return request({
    url: '/api/system/shopChargeRules/queryShopChargeRulesPage',
    method: 'post',
    data: query
  });
}

export function getShopChargeRulesList(query) {
  return request({
    url: '/api/system/shopChargeRules/queryShopChargeRulesList',
    method: 'post',
    data: query
  });
}

export function updateShopChargeRules(form) {
  return request({
    url: '/api/system/shopChargeRules/updateShopChargeRules',
    method: 'post',
    data: form
  });
}

export function saveShopChargeRules(form) {
  return request({
    url: '/api/system/shopChargeRules/saveShopChargeRules',
    method: 'post',
    data: form
  });
}

export function deleteShopChargeRules(id) {
  return request({
    url: '/api/system/shopChargeRules/deleteShopChargeRules',
    method: 'post',
    data: {'id': id}
  });
}

export function getShopChargeRulesById(id) {
  return request({
    url: '/api/system/shopChargeRules/getShopChargeRules',
    method: 'post',
    data: {'id': id}
  });
}



// WEBPACK FOOTER //
// ./src/api/chargeRules.js